<div class="privacy-dialog-content">
  <div class="scrollable-content" #scrollableContent>
    <div [innerHTML]="privacyNoticeContent"></div>
  </div>
  <div class="footer privacy">
    <div class="checkbox-container">
      <input type="checkbox" id="isRead" [(ngModel)]="isRead" />
      <label for="isRead">{{ 'iHaveReadAndAcknowledge' | translate }}</label>
    </div>
    <button type="button" class="ey-secondary-dark me-2 mt-0" (click)="onAcknowledge()" [disabled]="!isRead">
      {{'proceed' | translate }}
    </button>
  </div>
</div>